import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { TopicRepository } from '../../data/topic/topic.repository';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as dayjs from 'dayjs';

// import topicsImport from './dc3-topics.json';
// import entriesImport from './dc3-entries.json';
import { TopicApi } from '../../data/topic/topic.api';
import { EntryApi } from '../../data/entry/entry.api';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  @ViewChild('backupDownloadAnchor') backupDownloadAnchor: any;

  topicApi = inject(TopicApi);
  entryApi = inject(EntryApi);

  backupDownloadString: SafeUrl | undefined;
  backupFileName = '';

  // topics$ = this.topicRepository.topics$.pipe(
  //   map(topics => topics.sort((x, y) => {
  //     return !!x.range_target === !!y.range_target ? 0 : !!x.range_target ? -1 : 1;
  //   }))
  // );

  constructor(private topicRepository: TopicRepository,
              private sanitizer: DomSanitizer) {
    (window as any)['dc3Settings'] = this;
  }

  ngOnInit() {

  }

  // async import() {
  //   const topics = await firstValueFrom(this.topicRepository.topics$);
  //   const topicIdMap = new Map<string, number>();
  //
  //   topics.forEach(newTopic => {
  //     const oldTopicId = topicsImport.find(x => x.name === newTopic.name)?.id;
  //     if(oldTopicId) {
  //       topicIdMap.set(oldTopicId, newTopic.id)
  //     } else {
  //       console.log('could not find topic for ', newTopic);
  //     }
  //   })
  //   console.log(topicIdMap);
  //
  //   console.log('importlength', entriesImport.length)
  //   console.log('empty entries', entriesImport.filter(x => !x.value && !x.content).length)
  //   const importEntries: TablesInsert<'entries'>[] = entriesImport
  //     .filter(x => !!x.value || !!x.content)
  //     .map((e, index) => ({
  //       value: e.value || null,
  //       topic_id: topicIdMap.get(e.topicId)!,
  //       date: dayjs(e.date).format(dateFormat),
  //       content: e.content || null
  //     }));
  //   console.log('full import:', importEntries.length);
  //   console.log('noTopic: ', importEntries.filter(x => !x.topic_id));
  //   console.log('emptyEntries: ', importEntries.filter(x => !x.value && !x.content));
  //   // this.topicApi.addMultiple(importTopics);
  //   this.entryApi.insert(importEntries);
  // }

  downloadBackup() {
    if (this.backupDownloadAnchor) {
      const data = {
        entries: localStorage.getItem('entries@store'),
        topics: localStorage.getItem('topics@store')
      }
      console.log(data);
      const jsonString = JSON.stringify(data);
      const uri = this.sanitizer.bypassSecurityTrustUrl('data:text/json;charset=UTF-8,' + encodeURIComponent(jsonString));
      this.backupDownloadString = uri;
      this.backupFileName = `dc3-${dayjs().unix()}.json`;
      setTimeout(() => {
        this.backupDownloadAnchor.nativeElement.click()
      })
    }
  }

}
